"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateAndUploadWord = void 0;
var collectionsRef_1 = require("common/db/collectionsRef");
var docxtemplater_1 = __importDefault(require("docxtemplater"));
var pizzip_1 = __importDefault(require("pizzip"));
var utils_1 = __importDefault(require("pizzip/utils"));
var formServiceAgreementIDA_docx_1 = __importDefault(require("portal/assets/formServiceAgreementIDA.docx"));
var firebaseUploadAndGetUrl_1 = require("./firebaseUploadAndGetUrl");
var generateAndUploadWord = function (TemplateFile, templateData, SCId) { return __awaiter(void 0, void 0, void 0, function () {
    function loadFile(url, callback) {
        utils_1.default.getBinaryContent(formServiceAgreementIDA_docx_1.default, callback);
    }
    return __generator(this, function (_a) {
        loadFile(TemplateFile, function (error, content) {
            console.log({ error: error, content: content });
            if (error) {
                throw error;
            }
            function replaceErrors(key, value) {
                if (value instanceof Error) {
                    return Object.getOwnPropertyNames(value).reduce(function (error, key) {
                        error[key] = value[key];
                        return error;
                    }, {});
                }
                return value;
            }
            function errorHandler(error) {
                console.log(JSON.stringify({ error: error }, replaceErrors));
                if (error.properties && error.properties.errors instanceof Array) {
                    var errorMessages = error.properties.errors
                        .map(function (error) {
                        return error.properties.explanation;
                    })
                        .join("\n");
                    console.log("errorMessages", errorMessages);
                }
                throw error;
            }
            var zip = new pizzip_1.default(content);
            var doc;
            try {
                doc = new docxtemplater_1.default(zip);
            }
            catch (error) {
                errorHandler(error);
            }
            function dataRun(doc) {
                var _a;
                return __awaiter(this, void 0, void 0, function () {
                    var SCitemsSN, SCItemsData, fileR, file, url, error_1;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, collectionsRef_1.SCItemsRef.where("SCId", "==", SCId).get()];
                            case 1:
                                SCitemsSN = _b.sent();
                                SCItemsData = SCitemsSN.docs.map(function (item) {
                                    return __assign({}, item.data());
                                });
                                _b.label = 2;
                            case 2:
                                _b.trys.push([2, 6, , 7]);
                                doc.setData(__assign(__assign({}, templateData), SCItemsData[0]));
                                return [4 /*yield*/, doc.render()];
                            case 3:
                                fileR = _b.sent();
                                file = fileR.getZip().generate({ type: "nodebuffer" });
                                return [4 /*yield*/, (0, firebaseUploadAndGetUrl_1.firebaseUploadAndGetUrl)(file, "SC", templateData.CONTRACTNO)];
                            case 4:
                                url = _b.sent();
                                return [4 /*yield*/, collectionsRef_1.SCRef.doc(SCId)
                                        .update({
                                        SCURL: url,
                                        requestedAt: new Date(),
                                        requestedBy: templateData.userName,
                                        status: "approved",
                                        totalCostInLira: templateData.exchangeRate * ((_a = SCItemsData[0]) === null || _a === void 0 ? void 0 : _a.totalPrice),
                                    })
                                        .then(function () {
                                        collectionsRef_1.ordersRef.doc(templateData.orderId).update({
                                            status: "preparingSCNs",
                                        });
                                    })];
                            case 5:
                                _b.sent();
                                return [3 /*break*/, 7];
                            case 6:
                                error_1 = _b.sent();
                                errorHandler(error_1);
                                return [3 /*break*/, 7];
                            case 7: return [2 /*return*/];
                        }
                    });
                });
            }
            console.log({ doc: doc });
            dataRun(doc);
        });
        return [2 /*return*/];
    });
}); };
exports.generateAndUploadWord = generateAndUploadWord;
